import { Modal } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Outlet, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { PersonList } from "../components/PersonList";
import { fetchCaretakers } from "../features/caretaker/caretakersSlice";
import { Person } from "../model/person";
import { RouteNames } from "../routes";
import { useTranslate } from "../i18n";
import { formatPhone } from "../utils/formatPhone";
import { getErrorMessage } from "../utils/getErrorMessage";

export const CaretakersPage = () => {
    const dispatch = useAppDispatch();
    const t = useTranslate();
    const caretakers = useAppSelector((state) => state.caretakers.caretakers);
    const status = useAppSelector((state) => state.caretakers.status);
    const error = useAppSelector((state) => state.caretakers.error);
    const countries = useAppSelector((state) => state.country.countries);

    const navigate = useNavigate();
    const params = useParams();

    const isEditPage = params.caretakerId !== undefined;
    const onEditCaretaker = (id?: String) => {
        navigate(`/${RouteNames.caretakers}/${id}`);
    }

    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchCaretakers());
        }

    });

    const [isErrorDismissed, setIsErrorDismissed] = useState(false);

    const reloadCaretakers = () => {
        setIsErrorDismissed(false);
        dispatch(fetchCaretakers());
    }

    const onSearch = (query: string) => {
        dispatch(fetchCaretakers({ q: query }));
    }

    const handleOk = () => {
        setIsErrorDismissed(true);
        dispatch(fetchCaretakers());
    }

    const handleCancel = () => {
        setIsErrorDismissed(true);
    }

    if (isEditPage) {
        return <Outlet />;
    }

    const failed = status === "error" || status === "auth-error";
    const errorMessage = getErrorMessage(error, t);

    //todo implement server side paging and sorting
    return (<>
        <PersonList
            persons={caretakers?.map<Person>((caretaker) => {
                return {
                    id: caretaker.id ?? "",
                    firstName: caretaker.firstName ?? "",
                    lastName: caretaker.lastName ?? "",
                    phoneNumber: formatPhone(caretaker.userAccount?.mobileNumber, countries),
                    email: caretaker.userAccount?.emailAddress ?? ""
                };
            }) ?? []}
            title={t("nav.caretakers")}
            loading={status === "loading" || status === "idle"}
            onEditPerson={onEditCaretaker}
            onReload={reloadCaretakers}
            onSearch={onSearch}
        />
        <Modal
            title={errorMessage.title}
            visible={failed && !isErrorDismissed}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={t("common.retry")}
        >
            <p>{errorMessage.details}</p>
        </Modal>
    </>);
}
